export default "<!--<p>{{ message | async }}</p>-->\n  <button type=\"button\" (click)=\"logMeout()\">Log Out </button>\n"